import React from 'react';

import { ACCEPTABLE_FILE_FORMATS_STRING } from '../../common';
import { IModalProps } from '../../../../Common/Modal';

import { BasicErrorModal } from './Base';

const HEADLINE: string = "We aren't able to accept that filetype.";
const MESSAGE: JSX.Element = (
  <>
    Acceptable file formats include <br />{ACCEPTABLE_FILE_FORMATS_STRING}
  </>
);

export const BadFileType: React.FunctionComponent<IModalProps> = ({
  close,
  show
}) => <BasicErrorModal show={show} close={close} headline={HEADLINE} message={MESSAGE} />;
